import {
  alphabeticalCompare,
  alphabeticalSort,
  Permission,
  RoleTemplateItem,
} from '@cims-online/shared'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import PermissionViewer from '../../../../../../PermissionViewer'
import { useOptionalDescriptionColumn } from 'components/CIMSTable/common/hooks/useDescriptionColumn'

export const useColumns = (): CIMSColumn<RoleTemplateItem>[] => {
  return [
    useNameColumn({
      help: HelpMessage.Administration.Roles.Name,
      width: 200,
      sort: { default: 'ascend' },
    }),
    useOptionalDescriptionColumn('Role Template'),
    {
      title: 'Permissions',
      width: 500,
      help: HelpMessage.Administration.Roles.Permissions,
      filter: {
        with: 'callback',
        items: [...Permission.pageToBasics.entries()]
          .sort(([a], [b]) => alphabeticalCompare(a.module, b.module, 'name'))
          .map(([{ id, name, module }, permissions]) => ({
            text: `${module.name}: ${name}`,
            value: id,
            children: permissions
              .sort(alphabeticalSort('name'))
              .map(({ name, id }) => ({
                text: name,
                value: id,
              })),
          })),
        onFilter: (val, { permissions }) => permissions.includes(val as string),
      },
      render: ({ permissions }) => (
        <PermissionViewer additionalPermissionIds={permissions} />
      ),
    },
  ]
}
